<dx-box
  #contactUsPage
  direction="col"
  width="100%"
  height="100%"
  class="cc-contactus-container"
>
  <dxi-item baseSize="auto">
    <h2 [ngClass]="{ 'cc-text-center': isSmallScreen }">
      Contact Us
      <sup class="contactus-help-icon">
        <a
          [href]="helpLink"
          target="_blank"
          class="fa-solid fa-question-circle"
        ></a>
      </sup>
    </h2>
  </dxi-item>
  <dxi-item [ratio]="1" class="cc-white-background">
    <dx-box
      direction="col"
      width="100%"
      height="100%"
      class="cc-contactus-template-container"
    >
      <dxi-item baseSize="auto">
        <div *dxTemplate>
          <span *ngIf="!!selectedProperty">
            Please use this form to inquire about your account, report a common
            area maintenance problem, inquire about a pending architectural
            application or to give general comments or feedback. Your inquiry
            will be forwarded to the appropriate party and you will hear back
            quickly. You can upload as many supporting documents as you like
            using the document upload functionality below.
          </span>
          <p>
            You can call us at
            <strong>
              <a href="tel:{{ contactUsPhone }}">
                {{ contactUsPhoneDisplayText }}
              </a>
            </strong>
          </p>
        </div>
      </dxi-item>
      <dxi-item baseSize="auto" *ngIf="!!selectedProperty">
        <div *dxTemplate>
          <h4 class="contactus-form-title">Online Request Information</h4>
          <hr class="contactus-form-title-border" />
          <h5 class="contactus-community-name">
            {{ selectedProperty?.communityName }}
          </h5>
        </div>
      </dxi-item>
      <dxi-item [ratio]="1" *ngIf="!!selectedProperty">
        <dx-scroll-view width="100%" height="100%">
          <dx-responsive-box
            width="100%"
            height="100%"
            singleColumnScreen="sm"
            [(screenByWidth)]="getScreenByWidth"
          >
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-item>
              <dxi-location [row]="0" [col]="0"></dxi-location>
              <dx-box direction="col" width="100%" height="100%">
                <dxi-item baseSize="auto">
                  <div class="contactus-form-field">
                    <div class="contactus-form-label">
                      Category / Issue:
                      <sup class="cc-text-required">*</sup>
                    </div>
                    <dx-select-box
                      [dataSource]="issueCategories"
                      displayExpr="displayName"
                      valueExpr="categoryId"
                      seachEnabled="true"
                      [(value)]="selectedCategoryId"
                    >
                      <dxi-validation-rule
                        type="required"
                        message="Issue / Category is required"
                      ></dxi-validation-rule>
                    </dx-select-box>
                  </div>
                </dxi-item>
                <dxi-item baseSize="auto">
                  <div class="contactus-form-field">
                    <div class="description-label-container">
                      <span class="contactus-form-label">
                        Description:
                        <sup class="cc-text-required">*</sup>
                      </span>
                      <span>{{ descriptionLengthLeft }} characters left</span>
                    </div>
                    <dx-text-area
                      [inputAttr]="{
                        'allow-newlines': true,
                        'allow-extended': true
                      }"
                      [height]="isSmallScreen ? 60 : 120"
                      [maxLength]="300"
                      [(value)]="descriptionValue"
                      [(validationStatus)]="descriptionStatus"
                      valueChangeEvent="keyup change blur focusout"
                      (onValueChanged)="descriptionChanged()"
                    >
                      <dxi-validation-rule
                        type="required"
                        message="Description is required"
                      ></dxi-validation-rule>
                    </dx-text-area>
                  </div>
                </dxi-item>
              </dx-box>
            </dxi-item>
            <dxi-item
              [ngClass]="{
                'contactus-form-attachment-container': !isSmallScreen
              }"
            >
              <dxi-location [row]="0" [col]="1"></dxi-location>
              <div class="contactus-form-field">
                <div class="contactus-form-label">Attachments:</div>
                <dx-file-uploader
                  class="contactus-form-fileuploader"
                  selectButtonText="Select file"
                  uploadFailedMessage="Upload successful"
                  accept="*"
                  uploadMode="useButtons"
                  multiple="true"
                  [(value)]="selectedAttachments"
                ></dx-file-uploader>
              </div>
            </dxi-item>
          </dx-responsive-box>
        </dx-scroll-view>
      </dxi-item>
      <dxi-item baseSize="auto" *ngIf="!!selectedProperty">
        <div class="contactus-form-field">
          <dx-button
            stylingMode="contained"
            text="Submit Request"
            [icon]="saveIcon"
            type="success"
            [width]="130"
            (onClick)="submitOnlineRequest()"
          ></dx-button>
        </div>
      </dxi-item>
    </dx-box>
  </dxi-item>
</dx-box>

<dx-load-panel
  [position]="{ of: '#contactUsPage' }"
  [(visible)]="loadingVisible"
  message="Submitting..."
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
